import AppButton from '@theme/components/atom/AppButton'
import CatalogFilters from '@theme/components/catalog/CatalogFilters'
import CatalogFiltersMobile from '~/themes/base/components/catalog/CatalogFiltersMobile'

export default {
  extends: CatalogFiltersMobile,
  components: {
    AppButton,
    CatalogFilters,
  },
  props: {
    catalogState: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      displayCatalogFilters: false,
    }
  },
  methods: {
    updateFilters() {
      this.$emit('updateFilters')
    },
  },
}
